export enum ValuationRoutesEnum {
  VALUATION = 'valuation',
  ADD = 'add',
  MY_VALUATIONS = 'my-valuations',
}
export enum ValuationTypeEnum {
  ESTIMATION = 'ESTIMATION',
  PORTFOLIO = 'PORTFOLIO',
}

export enum ValuationPropertyViewEnum {
  SEA_VIEW = 'SEA_VIEW',
  CITY_VIEW = 'CITY_VIEW',
  GARDEN_VIEW = 'GARDEN_VIEW',
  POOL_VIEW = 'POOL_VIEW',
}

export enum ValuationFinishTypeEnum {
  LUXURY = 'LUXURY',
  SUPER_LUXURY = 'SUPER_LUXURY',
  SEMI_FINISHED = 'SEMI_FINISHED',
  CORE_SHELL = 'CORE_SHELL',
}
